import { type TimerDuration, useTimers } from "@src/appV2/lib/utils/useTimers";
import { useCallback, useEffect } from "react";

function buildTimerKey(shiftId: string): string {
  return `timesheet-submission-${shiftId}`;
}

interface UseTimesheetSubmissionTimerResult {
  stopTimesheetSubmissionTimer: () => TimerDuration | undefined;
}

export function useTimesheetSubmissionTimer(shiftId: string): UseTimesheetSubmissionTimerResult {
  const { start, stop, isRunning } = useTimers();
  const timerKey = buildTimerKey(shiftId);

  useEffect(() => {
    if (!isRunning(timerKey)) {
      start(timerKey);
    }
  }, [isRunning, start, timerKey]);

  const stopTimesheetSubmissionTimer = useCallback(() => {
    return stop(timerKey);
  }, [stop, timerKey]);

  return { stopTimesheetSubmissionTimer };
}
